import React, { useState, useEffect } from "react";
import { MsgToCar, SelectTagCar } from "../MapStyled";
import { useHookstate } from "@hookstate/core";
import { Modal } from "@mui/material";
import { Box } from "@mui/system";

import {
  MAP_GLOBAL_STATES,
  UPDATED_CAR_DATA_STATE,
  COMMON_COMPONENTS_STATES,
  FLEET_GLOBAL_STATES,
} from "globalStore/globalStore";
import { Tooltip } from "@mui/material";
import TimeFilterIcon from "assets/svgIcons/TimeFilterIcon";
import BatteryFilterIcon from "assets/svgIcons/BatteryFilterIcon";
import FilterCarIcon from "assets/svgIcons/FilterCarIcon";
import FilterFlagIcon from "assets/svgIcons/FilterFlagIcon";
import FilterShildIcon from "assets/svgIcons/FilterShildIcon";
import FilterDineIcon from "assets/svgIcons/FilterDineIcon";
import FilterBlockIcon from "assets/svgIcons/FilterBlockIcon";
import FilterTagsIcon from "assets/svgIcons/NotCommunicating";
import { useLocation } from "react-router-dom";
import CloseIcon from "../../../../../assets/svgIcons/CloseIcon";
import { useFilteredCarsHook } from "customHooks/useFilterData";
import CarSettingsNew from "commonComponents/CarDetails/CarSettingsNew";
import { useTranslation } from "react-i18next";

const style = {
  position: "fixed",
  maxWidth: "420px",
  width: "100%",
  bgcolor: "#ffffff",
  top: "10%",
  right: "0",
  left: "0",
  border: "0 solid #000",
  margin: "0 auto",
};

export const ChangeSettingsForSelectedCars = (props) => {
  const { t } = useTranslation();

  const {
    selectFleetCarsData2,
    closingPopup,
    selectedSpeedCarList,
    selectedGpsCarList,
  } = useHookstate(FLEET_GLOBAL_STATES);
  const [fleetCars, setFleetCars] = useState(true);
  const [specialCars, setSpecialCars] = useState(true);
  const [memberCars, setMemberCars] = useState(true);
  const [marshalCars, setMarshalCars] = useState(true);
  const [bewrageCars, setBewrageCars] = useState(true);
  const [notInUseCars, setNotInUseCars] = useState(true);
  const [carsNotCommunicating, setCarsNotCommunicating] = useState(true);
  const [highlightCar, setHighlightCar] = useState([]);
  const [filterIconColor, setFilterIconColor] = useState(false);
  const [filterIconColorTime, setFilterIconColorTime] = useState(false);
  const [filterIconColorBattery, setFilterIconColorBattery] = useState(false);
  const [filterIconColorBatteryRed, setFilterIconColorBatteryRed] =
    useState(false);
  const [carData, setCarData] = useState([]);
  const [carsToDisplay, setCarsToDisplay] = useState([]);
  const [carsType, setCarsTypeData] = useState([1, 3, 2, 4, 5, 6]);

  const { getSelectedCarsState } = useFilteredCarsHook({
    marshalCars: marshalCars,
    specialCars: specialCars,
    memberCars: memberCars,
    bewrageCars: bewrageCars,
    fleetCars: fleetCars,
    notInUseCars: notInUseCars,
    notCommunicatingCars: carsNotCommunicating,
    paceWarning: filterIconColor,
    paceCritical: filterIconColorTime,
    batteryWarning: filterIconColorBattery,
    batteryCritical: filterIconColorBatteryRed,
  });
  const {
    showTagCarsStatenew,
    AllShow,
    carList,
  } = useHookstate(COMMON_COMPONENTS_STATES);

  const { pathname } = useLocation();
  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);

  useEffect(() => {
    let localCarData =
      !Array.isArray(updatedCarData.get()) &&
      typeof updatedCarData.get() === "string" &&
      JSON.parse(updatedCarData.get());

    if (
      updatedCarData.get() &&
      Array.isArray(localCarData) &&
      localCarData.length !== 0
    ) {
      setCarData(localCarData);
    } else {
      setCarData([]);
    }
  }, [updatedCarData.get()]);

  const carStatusData = [
    {
      id: 1,
      iconName: (
        <TimeFilterIcon
          bg={
            filterIconColor
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FFE500"
          stroke={
            filterIconColor
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },

    {
      id: 2,
      iconName: (
        <TimeFilterIcon
          bg={
            filterIconColorTime
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FA3C30"
          stroke={
            filterIconColorTime
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },

    {
      id: 3,
      iconName: (
        <BatteryFilterIcon
          bg={
            filterIconColorBattery
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FFE500"
          stroke={
            filterIconColorBattery
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },

    {
      id: 4,
      iconName: (
        <BatteryFilterIcon
          bg={
            filterIconColorBatteryRed
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FA3C30"
          stroke={
            filterIconColorBatteryRed
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },
  ];

  const {
    taggedCarsDisplayerGlobalState,
    showTaggedGpsArray,
    showTaggedCarArray,
    showTaggedCarArrayNew,
    showSpeedCar,
    showDistanceCar,
    showCarType,
    showMaxHolesCar,
  } = useHookstate(MAP_GLOBAL_STATES);

  const handleSettingClose = () => {
    setIsShownCarDetail(false);
    setOpenSettingModal(false);
    showTagCarsStatenew.set(false);
  };

  const setCarsType = (value) => {
    let data = [...carsType];
    if (data.some((it) => it == value)) {
      data.splice(
        data.findIndex((it) => it == value),
        1
      );
    } else data.push(value);
    setCarsTypeData(data);
  };

  useEffect(() => {
    showFilteredCars();
  }, [
    filterIconColor,
    filterIconColorBattery,
    filterIconColorTime,
    filterIconColorBatteryRed,
    fleetCars,
    marshalCars,
    bewrageCars,
    carsNotCommunicating,
    notInUseCars,
    specialCars,
    memberCars
  ]);

  const showFilteredCars = () => {
    let getCarsData = JSON.parse(JSON.stringify(getSelectedCarsState.get()));
    let filterCars = [...getCarsData];
    var tagCars =
      filterCars && filterCars.length !== 0
        ? filterCars.filter((it) =>
          showTaggedCarArray.get().some((item) => item === it.Car.CarNumber)
        )
        : "";

    setHighlightCar(
      tagCars && tagCars.length !== 0
        ? tagCars.map((it) => it.Car.CarNumber)
        : []
    );
    setCarsToDisplay(filterCars);
  };

  const setTagCarOnMap = (
    carData,
    carNumber,
    GpsiCarId,
    MaxSpeed,
    DistanceUnits,
    CarType,
    MaxHolesAllowedCar
  ) => {
    const carGpsiCarIdExist = selectedGpsCarList
      .get()
      .find((item) => item === GpsiCarId);
    if (carGpsiCarIdExist) {
      selectedGpsCarList.set((tasks) =>
        tasks.filter((item) => item !== GpsiCarId)
      );
    } else {
      selectedGpsCarList.set((item) => [...item, GpsiCarId]);
    }

    const carSpeedExist = selectedSpeedCarList
      .get()
      .find((item) => item == MaxSpeed);
    if (carSpeedExist) {
      selectedSpeedCarList.set((tasks) =>
        tasks.filter((item) => item == MaxSpeed)
      );
    } else {
      selectedSpeedCarList.set((item) => [...item, MaxSpeed]);
    }

    const carDataExist = selectFleetCarsData2
      .get()
      .find((item) => item?.CarNumber === carNumber);

    if (carDataExist) {
      selectFleetCarsData2.set((tasks) =>
        tasks.filter((item) => item?.CarNumber !== carNumber)
      );
    } else {
      selectFleetCarsData2.set((item) => [...item, carData]);
    }
    let _arr = [...showTaggedGpsArray.get()];

    _arr.push(GpsiCarId);

    showTaggedGpsArray.set(_arr);

    const exist = highlightCar.find((item) => item === carNumber);

    if (exist) {
      let newData = highlightCar.filter((item) => item !== carNumber);

      setHighlightCar(newData);
    } else {
      setHighlightCar([...highlightCar, GpsiCarId]);
    }

    const exist2 = showTaggedCarArrayNew
      .get()
      .find((item) => item === carNumber);
    const speedExist = showSpeedCar.get().find((item) => item === MaxSpeed);
    const distanceExist = showDistanceCar
      .get()
      .find((item) => item === DistanceUnits);
    const CarTypeExist = showCarType.get().find((item) => item === CarType);
    const MaxHolesExist = showMaxHolesCar
      .get()
      .find((item) => item === MaxHolesAllowedCar);
    if (exist2) {
      showTaggedCarArrayNew.set((tasks) =>
        tasks.filter((task) => task !== carNumber)
      );
    } else {
      showTaggedCarArrayNew.set((tasks) => [...tasks, carNumber]);
    }
    if (speedExist) {
      showSpeedCar.set((tasks) => tasks.filter((task) => task == MaxSpeed));
    } else {
      showSpeedCar.set((tasks) => [...tasks, MaxSpeed]);
    }
    if (distanceExist) {
      showDistanceCar.set((tasks) =>
        tasks.filter((task) => task == DistanceUnits)
      );
    } else {
      showDistanceCar.set((tasks) => [...tasks, DistanceUnits]);
    }
    if (CarTypeExist) {
      showCarType.set((tasks) => tasks.filter((task) => task == CarType));
    } else {
      showCarType.set((tasks) => [...tasks, CarType]);
    }
    if (MaxHolesExist) {
      showMaxHolesCar.set((tasks) =>
        tasks.filter((task) => task == MaxHolesAllowedCar)
      );
    } else {
      showMaxHolesCar.set((tasks) => [...tasks, MaxHolesAllowedCar]);
    }
  };

  const [isShownCarDetail, setIsShownCarDetail] = useState(false);

  const [openSettingModal, setOpenSettingModal] = React.useState(false);
  const Showpopup = () => {
    setIsShownCarDetail(true);
    setOpenSettingModal(true);
  };
  const resetData = () => {
    setFilterIconColor(false);
    setFilterIconColorTime(false);
    setFilterIconColorBattery(false);
    setFilterIconColorBatteryRed(false);
    setFleetCars(true);
    setMarshalCars(true);
    setBewrageCars(true);
    setSpecialCars(true);
    setMemberCars(true);
    setCarsNotCommunicating(true);
    setNotInUseCars(true);
    selectCarsData("none");
  };
  const selectCarsData = (selectionType) => {
    if (selectionType === "all" && carsToDisplay.length !== 0) {
      selectFleetCarsData2.set(carsToDisplay.map((it) => it?.Car));
      carList.set(carsToDisplay);
      let cars = carsToDisplay.map((it) => it.Car.CarNumber);
      setHighlightCar(cars);
      AllShow.set(false);
      showTaggedCarArrayNew.set(cars);
      showSpeedCar.set(cars);
      showMaxHolesCar.set(cars);
      showDistanceCar.set(cars);
      showCarType.set(cars);
      taggedCarsDisplayerGlobalState.set(true);
    } else {
      selectFleetCarsData2.set([]);
      AllShow.set(true);
      setHighlightCar([]);
      showSpeedCar.set([]);
      showCarType.set([]);
      showMaxHolesCar.set([]);
      showDistanceCar.set([]);
      taggedCarsDisplayerGlobalState.set(false);
      showTaggedCarArrayNew.set([]);
      AllShow.set(true);
    }
  };

  const cars = carsToDisplay.filter((item) =>
    showTaggedCarArrayNew.get().find((item1) => item1 === item.Car.CarNumber)
  );

  const [Setting, setSetting] = React.useState("Use fleet setting");

  const [newCarType, setCarType] = React.useState("Normal");

  function cartypecheck() {
    switch (newCarType) {
      case "Normal":
        return 0;
      case "Fleet Car":
        return 1;
      case "Marshal Car":
        return 2;
      case "Special Need Car":
        return 3;
      case "Beverage Car":
        return 4;
      default:
        return <span className="card-view">Not Available Car Name</span>;;
    }
  }

  function MxnumberOfHoles() {
    switch (Setting) {
      case "Use fleet setting":
        return -1;
      case 9:
        return 9;
      case 18:
        return 18;
      default:
        return 0;
    }
  }

  function DistanceUnitsEnableCar() {
    switch (Setting) {
      case "Hide Distances":
        return 0;
      case "Show Distances":
        return 1;
      default:
        return 2;
    }
  }

  const handleOkHandler = () => {
    closingPopup.set(true);
    showTagCarsStatenew.set(false);
  };

  return (
    <>
      <Modal
        open={showTagCarsStatenew.get()}
        onClose={() => showTagCarsStatenew.set(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <SelectTagCar
            className={pathname === "/fleet" && "fleet-find-car-section"}
          >
            <div className="inner-wrapper">
              <div className="box-heading">
                <h5>{t("Select_Cars")}</h5>
                <div className="close-icon-wrapper">
                  <CloseIcon
                    width={22}
                    height={22}
                    onClick={() => showTagCarsStatenew.set(false)}
                  />
                </div>
              </div>

              <div className="filter">
                <p>{t("Filter")}</p>
                <div>
                  {carStatusData &&
                    carStatusData.map((item) => (
                      <Tooltip
                        title={
                          item.id === 1
                            ? t("Cars_Pace_Warning")
                            : item.id === 2
                              ? t("Cars_Pace_Critical")
                              : item.id === 3
                                ? t("Cars_Battery_Warning")
                                : t("Cars_Battery_Critical")
                        }
                        placement="top"
                        arrow
                      >
                        <button
                          key={item.id}
                          onClick={() =>
                            item.id == 1
                              ? setFilterIconColor(!filterIconColor)
                              : item.id == 2
                                ? setFilterIconColorTime(!filterIconColorTime)
                                : item.id == 3
                                  ? setFilterIconColorBattery(
                                    !filterIconColorBattery
                                  )
                                  : setFilterIconColorBatteryRed(
                                    !filterIconColorBatteryRed
                                  )
                          }
                        >
                          {item.iconName}
                        </button>
                      </Tooltip>
                    ))}
                </div>
              </div>

              <div className="white-filter">
                <Tooltip title={t("Fleet_cars")} placement="top" arrow>
                  <button
                    onClick={() => {
                      setCarsType(1);
                      setFleetCars(!fleetCars);
                    }}
                  >
                    <FilterCarIcon
                      bgcolor={
                        fleetCars
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={
                        fleetCars
                          ? "var(--input-background)"
                          : "var(--text-secondary)"
                      }
                      border={fleetCars ? "#FFE500" : "#707374"}
                    />
                  </button>
                </Tooltip>
                <Tooltip title={t("Marshal_cars")} placement="top" arrow>
                  <button
                    onClick={() => {
                      setCarsType(2);
                      setMarshalCars(!marshalCars);
                    }}
                  >
                    {" "}
                    <FilterShildIcon
                      bgcolor={
                        marshalCars
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={
                        marshalCars ? "var(--input-background)" : "#49B3E0"
                      }
                      border={
                        marshalCars
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                    />
                  </button>
                </Tooltip>
                <Tooltip title={t("Beverage_cars")} placement="top" arrow>
                  <button
                    onClick={() => {
                      setCarsType(4);
                      setBewrageCars(!bewrageCars);
                    }}
                  >
                    <FilterDineIcon
                      bgcolor={
                        bewrageCars
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={
                        bewrageCars ? "var(--input-background)" : "#229D08"
                      }
                      border={
                        bewrageCars
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                    />
                  </button>
                </Tooltip>
                <Tooltip title={t("Special_needs_cars")} placement="top" arrow>
                  <button
                    onClick={() => {
                      setCarsType(3);
                      setSpecialCars(!specialCars);
                    }}
                  >
                    <FilterFlagIcon
                      bgcolor={
                        specialCars
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={
                        specialCars ? "var(--input-background)" : "#0026AC"
                      }
                      border={
                        specialCars
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                    />
                  </button>
                </Tooltip>
                <Tooltip title={t("Cars_not_in_use")} placement="top" arrow>
                  <button
                    onClick={() => {
                      setCarsType(5);
                      setNotInUseCars(!notInUseCars);
                    }}
                  >
                    <FilterBlockIcon
                      bgcolor={
                        notInUseCars
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={
                        notInUseCars ? "var(--input-background)" : "#FA3C30"
                      }
                      border={
                        notInUseCars
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                    />
                  </button>
                </Tooltip>
                <Tooltip
                  title={t("Cars_not_communicating")}
                  placement="top"
                  arrow
                >
                  <button
                    className={carsNotCommunicating ? "active not-com" : " not-com"}
                    onClick={() => {
                      setCarsType(6);
                      setCarsNotCommunicating(!carsNotCommunicating);
                    }}
                  >
                    <FilterTagsIcon

                      bgColor={
                        carsNotCommunicating
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={
                        carsNotCommunicating
                          ? "var(--input-background)"
                          : "#3134EB"
                      }
                      border={
                        carsNotCommunicating
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                      fill={
                        carsNotCommunicating
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                    />
                  </button>
                </Tooltip>               
              </div>

              <div className="car-selection">
                <div className="car-count">
                  <div>
                    <p onClick={() => selectCarsData("all")}>{t("All")}</p> I{" "}
                    <p onClick={() => selectCarsData("none")}>{t("None")}</p>
                  </div>

                  <div>
                    {
                      carsToDisplay.filter((item) =>
                        showTaggedCarArrayNew
                          .get()
                          .find((item1) => item1 === item.Car.CarNumber)
                      ).length
                    }
                    &nbsp;
                    {showTaggedCarArrayNew.get().length > 1
                      ? t("cars_selected")
                      : t("car_selected")}
                  </div>
                </div>

                <div
                  className="car-number"
                  style={{
                    maxHeight: 116,
                    overflow: "auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                  }}
                >
                  {carsToDisplay.length > 0 ? (
                    carsToDisplay
                      .sort((a, b) => a.Car.CarNumber - b.Car.CarNumber)
                      .map((item, index) => (
                        <button
                          key={index}
                          className={
                            showTaggedCarArrayNew
                              .get()
                              .find((item3) => item3 === item.Car.CarNumber)
                              ? 
                              "active"
                              : ""
                          }
                          onClick={() =>
                            setTagCarOnMap(
                              item?.Car,
                              item?.Car?.CarNumber,
                              item?.Car?.GpsiCarId,
                              item?.Car?.MaxSpeed,
                              item?.Car?.DistanceUnits,
                              item?.Car?.CarType,
                              item?.Car?.MaxHolesAllowedCar
                            )
                          }
                        >
                          {item.Car.CarNumber}
                        </button>
                      ))
                  ) : (
                    <p>No car number found</p>
                  )}
                </div>

                <MsgToCar>
                  <div className="action-wrapper">
                    <button
                      disabled={selectFleetCarsData2.get().length === 0}
                      onClick={handleOkHandler}
                      className={
                        selectFleetCarsData2.get().length === 0
                          ? "disabled"
                          : "active"
                      }
                    >
                      {t("Ok")}
                    </button>

                    {isShownCarDetail && (
                      <Modal
                        open={openSettingModal}
                        onClose={handleSettingClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={style}>
                          <CarSettingsNew onClose={handleSettingClose} />
                        </Box>
                      </Modal>
                    )}

                    <button
                      className="send-btn"
                      onClick={() => showTagCarsStatenew.set(false)}
                    >
                      {t("Cancel")}
                    </button>
                    <button className="send-btn" onClick={resetData}>
                      {t("Reset")}
                    </button>
                  </div>
                </MsgToCar>
              </div>
            </div>
          </SelectTagCar>
        </Box>
      </Modal>
    </>
  );
};
